import { Dispatch } from 'react';
import { useSelector } from 'react-redux';
import { Action } from 'redux';
import { StoreState } from '@/redux/types';
import { DraftAction } from '@/components/draft/draftState/types';

export type DraftDispatch = Dispatch<DraftAction>;

export const SetDraftDispatchType = '@draftDispatch/set';

export interface SetDraftDispatch extends Action {
  type: typeof SetDraftDispatchType;
  dispatch: DraftDispatch;
}

const initialDispatch = (mutation: DraftAction) => {
  if (process.env.NODE_ENV === 'development') {
    console.groupCollapsed('draftDispatch');
    console.log(mutation);
    console.trace();
    console.groupEnd();
  } else {
    console.log(mutation);
  }
};

export const draftDispatch = (
  dispatch: DraftDispatch = initialDispatch,
  action: SetDraftDispatch
): DraftDispatch => {
  if (action.type === SetDraftDispatchType) {
    return action.dispatch;
  }
  return dispatch;
};

export const setDraftDispatch = (dispatch: DraftDispatch): SetDraftDispatch => ({
  type: SetDraftDispatchType,
  dispatch,
});

export const getDraftDispatch = (state: StoreState) => state.draftDispatch;

export const useReduxDraftDispatch = () => useSelector(getDraftDispatch);
